<template>
  <div v-loading="loading" class="content">
    <!-- 上边 -->
    <el-row style="margin-bottom:10px">
      <el-col :span="12" style="display: flex;">
        <search @success="init()">
          <el-form>
            <el-form-item label="库存金额为0 ：" :label-width="formLabelWidth">          
              <el-radio-group v-model="listQuery.hideEndAmount0">
                <el-radio :label="true">隐藏</el-radio>
                <el-radio :label="false">显示</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="销售金额为0 ：" :label-width="formLabelWidth">   
              <el-radio-group v-model="listQuery.hideSoldAmount0">
                <el-radio :label="true">隐藏</el-radio>
                <el-radio :label="false">显示</el-radio>
              </el-radio-group>
            </el-form-item>
         
          </el-form>
        </search>
     
        <el-button style="margin-left:10px" size="mini" type="primary" plain @click="init(1)">刷新</el-button>

        <el-button size="mini" type="success" plain @click="oneKeyLl()">一键领料</el-button>
        <el-button size="mini" type="success" plain @click="ablck()">按比例出库</el-button>
      </el-col>
      <el-col :span="12">
        <div style="float:right">
          <span v-if="info.statusDetail" class="machine">已完成服务成本核算<span class="degree">{{info.statusDetail.fwCount}}</span>次</span>
          <el-button size="mini" type="success" plain @click="doProduceClick()">领料出库</el-button>
          <el-button size="mini" type="success" plain @click="doProduce(1)">暂存</el-button>
          <el-button size="mini" v-if="info.statusDetail && info.statusDetail.fwCount" type="warning" plain @click="reset()">重置领料出库</el-button>
          <costSetting type="fw"></costSetting>
        </div>
      </el-col>
    </el-row>

    <!-- 左边 -->
    <div class="left-content">
      <!-- 其他费用 -->
      <div v-if="info.leftFee" class="left-content-item">
          <!-- title -->
          <div class="left-total">
              出库总金额：{{total.ckzje}}
          </div>
          <div class="left-title">
              其他费用
          </div>
          <el-row v-for="(item,index) in info.leftFee" :key="index">
            <el-col :span="16">
              <div class="left-box">
                {{item.name}}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="left-box">
                <input @change="leftTotal()" v-model.number="item.amount" placeholder="请输入金额" />
              </div>
            </el-col>
          </el-row>
      </div>


      <!-- 存货原材料 -->
      <div class="left-content-item">
        <el-row>
          <!-- title -->
          <div class="left-title">
            <!-- <el-col :span="24"> -->
              原材料
            <!-- </el-col> -->
          </div>

          <el-col :span="6">
            <div class="left-box">
              名称
            </div>
          </el-col>
          <el-col :span="2">
            <div class="left-box">
              类型
            </div>
          </el-col>
          <el-col :span="2">
            <div class="left-box">
              单位
            </div>
          </el-col>
          <el-col :span="2">
            <div class="left-box">
              存货数量
            </div>
          </el-col>
          <el-col :span="2">
            <div class="left-box">
              存货单价
            </div>
          </el-col>
          <el-col :span="2">
            <div class="left-box">
              存货金额
            </div>
          </el-col>
          
          <el-col :span="2">
            <div class="left-box">
              出库数量
            </div>
          </el-col>
          <el-col :span="2">
            <div class="left-box">
              出库单价
            </div>
          </el-col>
          <el-col :span="2">
            <div class="left-box">
              出库金额
            </div>
          </el-col>
          <el-col :span="2">
            <div class="left-box">
              结算后数量
            </div>
          </el-col>
        </el-row>


        <!-- 明细 -->
        <el-row v-for="(item,index) in info.leftInventory" :key="index">
          <!-- title -->
          <el-col :span="24">
            <div class="leftOne subject">
              <span>原材料名{{item.name}}</span>
              <span>数量：{{item.count}}</span>
              <span>金额：{{item.amount}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <el-row v-for="(itemInventory,indexInventory) in item.inventorys" :key="indexInventory">
              <el-col :span="6">
                <div class="left-box">
                  {{itemInventory.name}}
                </div>
              </el-col>
              <el-col :span="2">
                <div class="left-box">
                  {{$inventoryTypeFilter(itemInventory.inventoryType)}}
                </div>
              </el-col>
              <el-col :span="2">
                <div class="left-box">
                  {{itemInventory.unit}}
                </div>
              </el-col>
              <el-col :span="2">
                <div class="left-box">
                  {{itemInventory.count}}
                </div>
              </el-col>
              <el-col :span="2">
                <div class="left-box">
                  <span v-if="itemInventory.count">{{(itemInventory.amount/itemInventory.count).toFixed(2)}}</span>
                  <span v-else>0</span>
                </div>
              </el-col>
              <el-col :span="2">
                <div class="left-box">
                  {{itemInventory.amount}}
                </div>
              </el-col>
              
              <el-col :span="2">
                <div class="left-box">
                  <input @change="changeLeft(itemInventory, 'count', item)" v-model.number="itemInventory.useCount" placeholder="请输入出库数量" />
                </div>
              </el-col>
              <el-col :span="2">
                <div class="left-box">
                  <input @change="changeLeft(itemInventory, 'price', item)" v-model.number="itemInventory.usePrice" placeholder="请输入出库单价" />
                </div>
              </el-col>
              <el-col :span="2">
                <div class="left-box">
                  <input @change="changeLeft(itemInventory, 'amount', item)" v-model.number="itemInventory.useAmount" placeholder="请输入出库金额" />
                </div>
              </el-col>
              <el-col :span="2">
                <div class="left-box">
                  {{(itemInventory.count-itemInventory.useCount).toFixed(2)}}
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 右边 抽屉 -->
    <!-- <qzf-button class="right-button" @success="drawer = true">成本详情</qzf-button> -->
    <button class="right-button" @click="drawer = true">生产详情</button>
    <el-drawer v-model="drawer" size="80%" direction="rtl">
      <template #title>
        <h4>成本</h4>
      </template>
      <template #default>
        <div style="width:100%" class="left-content">

          <!-- 存货原材料 -->
          <div v-if="info.rightFw" class="left-content-item">
            <!-- title -->
            <div class="left-title">
                成本科目(分摊比例相加必须等于100)
            </div>
            <el-row>
              <el-col :span="16">
                <div class="left-box">
                  科目名称
                </div>
              </el-col>
              <el-col :span="8">
                <div class="left-box">
                  分摊比例（%）
                </div>
              </el-col>
            </el-row>

            <!-- 明细 -->
            <el-row v-for="(item,index) in info.rightFw" :key="index">
              <!-- title -->
              <el-col :span="16">
                <div class="left-box ">
                  {{item.name}}
                </div>
              </el-col>

              <el-col :span="8">
                <div class="left-box ">
                  <input v-model.number="item.bl" placeholder="请输入比例" />
                </div>
              </el-col>
              
            </el-row>
          </div>
        </div>

      </template>
      <template #footer>
        <div style="flex: auto">
          <el-button @click="cancelClick">cancel</el-button>
          <el-button type="primary" @click="confirmClick">confirm</el-button>
        </div>
      </template>
    </el-drawer>

    <!-- 暂估入库 -->
    <inventoryStock @success="zgrkSuccess" ref="zgrk" name="暂估入库"></inventoryStock>
  </div>
</template>

<script>
import { fwCheckInfo, fwCheck, reverseFw } from"@/api/inventory.js"
import inventoryStock from "./components/inventoryStock.vue"
import costSetting from "./components/costSetting.vue"
export default {
  name:'fwConvert',
  components: {
    inventoryStock,
    costSetting
  },
  data() {
    return {
      loading: false,
      formLabelWidth:'100px',
      drawer: false,
      listQuery: {
        refresh: 0,//1 强制刷新
        hideEndAmount0: true,//true 隐藏金额为0的
        hideSoldAmount0: true,//true 隐藏销售金额为0
      },
      info: {},
      total: {
        ckzje: 0,//出库总金额
      }
    }
  },
  created() {
    this.init()
  },
  methods:{
    changeLeft(item, type, subject){
      if(type == 'count'){
        if(item.usePrice){
          item.useAmount = (item.useCount * item.usePrice).toFixed(2) * 1
        }else{
          if(item.count){
            item.usePrice = (item.amount/item.count).toFixed(2) * 1
            item.useAmount = (item.useCount * item.usePrice).toFixed(2) * 1
          }
        }
      }else if(type == 'price'){
        item.useAmount = (item.useCount * item.usePrice).toFixed(2) * 1
      }else{
        if(item.useCount){
          item.usePrice = (item.useAmount/item.useCount).toFixed(2) * 1
        }
      }
      //计算科目合计
      let amount = 0
      let count = 0
      subject.inventorys.map(v=>{
        amount+=v.useAmount
        count+=v.useCount
      })
      subject.amount = parseFloat(amount.toFixed(2))
      subject.count = parseFloat(count.toFixed(6))
      this.leftTotal()
    },
    leftTotal(){
      //费用
      let feeAmount = 0
      if(this.info.leftFee){
        this.info.leftFee.map(v=>{
          feeAmount+=v.amount
        })
      }
      feeAmount = feeAmount.toFixed(2)*1
      //存货
      let inventoryAmount = 0
      if(this.info.leftInventory){
        this.info.leftInventory.map(v=>{
          if(v.amount){
            inventoryAmount+=v.amount
          }
        })
      }
      inventoryAmount = inventoryAmount.toFixed(2)*1

      this.total.ckzje = (feeAmount + inventoryAmount).toFixed(2) * 1
    },
    //初始化数据
    init(refresh){
      if(refresh){
        this.listQuery.refresh = 1
      }else{
        this.listQuery.refresh = 0
      }
      this.loading = true
      fwCheckInfo(this.listQuery).then(res=>{
        this.loading = false
        this.info = res.data.data.info
        this.initPrice()
      })
    },
    initPrice(){
      //计算缓存的出库单价
      if(this.info.leftInventory){
        this.info.leftInventory.map(subject=>{
          subject.inventorys.map(v=>{
            this.changeLeft(v, 'amount', subject)
          })
        })
      }
      this.leftTotal()
    },
    //执行领料加工
    doProduce(type){
      let param = {
        info: this.info,
        type,
      }
      this.loading = true
      fwCheck(param).then(res=>{
        this.loading = false
        if(res.data.msg == "success"){
          this.$qzfMessage("操作成功")
          this.$bus.emit('inventoryCheckUpdate')
          this.init()
        }
      })
    },
    //领料加工 确认
    doProduceClick(){
      //判断是否需要暂估入库
      let zgrkList = []
      if(this.info.leftInventory){
        this.info.leftInventory.map(subject=>{
          subject.inventorys.map(v=>{
            if((v.useCount - v.count) > 0){
              let count = parseFloat((v.useCount - v.count).toFixed(6) * 1)
              let amount = (v.useAmount - v.amount).toFixed(2) * 1
              zgrkList.push({
                count: count, // 数量
                amount:  amount,// 金额
                danjia: (amount/count).toFixed(2) * 1,
                inventoryId:v.id,
              })
            }
          })
        })
      }
      if(zgrkList.length != 0){
        this.$refs.zgrk.init(zgrkList)
        return
      }
      this.doProduce(0)
    },
    //暂估入库回调
    zgrkSuccess(info){
      info.items.map(zgrk=>{
        this.info.leftInventory.map(subject=>{
          subject.inventorys.map(v=>{
            if(v.id == zgrk.inventoryId){
              v.count = parseFloat((v.count + zgrk.count).toFixed(6) * 1)
              v.amount = (v.amount + zgrk.amount).toFixed(2) * 1
            }
          })
        })
      })
    },
    //一键领料
    oneKeyLl(){
      this.info.leftInventory.map(subject=>{
        subject.inventorys.map(v=>{
          v.useCount = v.count
          v.useAmount = v.amount
        })
      })
      this.initPrice()
    },
    ablck(){
      let that = this
      this.$prompt('请输入成本比例（%）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        // 成功的操作 写在这里
        let amount = this.total.sczje * value / 100
        that.inProportion(amount)
      })
    },
    //按比例出库
    inProportion(amount){
      if(amount == 0){
        this.$qzfMessage("生产总金额不可为0", 1)
        return
      }

      let amountSum = 0
      this.info.leftInventory.map(subject=>{
        subject.inventorys.map(v=>{
          amountSum+=v.amount
        })
      })
      if(amount > amountSum){
        this.$qzfMessage("成本大于当前存货总金额", 1)
        return
      }
      this.info.leftInventory.map(subject=>{
        subject.inventorys.map(v=>{
          v.useAmount = amountSum?(v.amount/amountSum*amount).toFixed(2) * 1:0
          v.usePrice = v.count?(v.amount/v.count).toFixed(2) * 1:0
          v.useCount = v.usePrice?parseFloat((v.useAmount/v.usePrice).toFixed(6) * 1):0
        })
      })
      this.initPrice()
    },
    //重置领料加工
    reset(){
      this.loading = true
      reverseFw({}).then(res=>{
        this.loading = false
        if(res.data.msg == "success"){
          this.info = res.data.data.info
          this.initPrice()
          this.$qzfMessage("重置成功")
          this.$bus.emit('inventoryCheckUpdate')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table{
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
.content{
  font-size: 14px;
  margin: 20px;
  text-indent: 4px;
  .machine {
    display: inline-block;
    font-size: 16px;
    margin-right: 20px;
    font-weight: 700;
    .degree {
      font-size: 20px;
      padding: 4px;
      color: red;
      font-weight: 700;
    }
  }
  .left-content{
    width: 96%;
    height: 500px;
  }
  .left-content-item{
    width: 100%;
    border: 1px solid #efefef;
    .left-total{
      width: 100%;
      background: #fff;
      height: 30px;
      text-align: left;
      line-height: 30px;
    }
    .left-title{
      width: 100%;
      background: $color-main;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: #fff;
    }
    .subject{
      background: #efefef;
    }
    .left-box{
      border-right: 1px solid #efefef;
      line-height: 30px;
      height: 30px;
      border-top: 1px solid #efefef;
      text-align: center;
      input {
        background-color: aliceblue;
      }
    }
    .leftOne {
      border-right: 1px solid #efefef;
      line-height: 30px;
      height: 30px;
      border-top: 1px solid #efefef;
      padding: 0 10px;
    }
    .leftOne span {
      padding-right: 25px;
    }
    &:last-child {
      border-right: none;
    }
  }
}
.right-button{
  position: fixed;
  top: 250px;
  right: 0;
  height: 120px;
  width: 40px;
  font-size: 16px;
  margin: 0 auto;  
  line-height: 24px;
  background: $color-main;
  color: #fff;
  border-color: $color-main;
  border: 0;
  cursor:pointer;
}
input{
  width: calc(100% - 10px);
  height: 100%;
  display: inline-block;
  outline: none;
}
</style>